import _ from "lodash";
import BaseSecondaryStickyView from "scripts/views/baseSecondaryStickyNavView";
import templateAnthologyCollectionPageNav from "templates/anthologyCollectionPageNav.hbs";

class AnthologyCollectionPageNavView extends BaseSecondaryStickyView {
  get template() {
    return templateAnthologyCollectionPageNav;
  }

  constructor(options) {
    super(options);

    this.anthologyCollectionModel = options.anthologyCollectionModel;
  }

  render() {
    this.$el.html(
      this.template(
        _.merge(
          {},
          this.model.toJSON(),
          this.anthologyCollectionModel.toJSON(),
        ),
      ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }
}

export default AnthologyCollectionPageNavView;
